import { ReactElement } from 'react';
import { Link } from '@mui/material';
import { getSchema } from '@localstack/services';
import Firehose from 'aws-sdk/clients/firehose';

import { MagicTable } from '../../magic/MagicTable';

export type FirehoseStreamsTableProps = {
  deliveryStreams: Firehose.DeliveryStreamDescription[];

  selectable?: boolean;
  loading?: boolean;
  onViewStream?: (stream: Firehose.DeliveryStreamDescription) => void;
  onSelect?: (ids: string[]) => void;
};

export const FirehoseStreamsTable = ({
  deliveryStreams,
  selectable = true,
  loading,
  onViewStream,
  onSelect,
}: FirehoseStreamsTableProps): ReactElement => (
  <MagicTable
    schema={getSchema('Firehose')}
    entry="DeliveryStreamDescription"
    idAttribute="DeliveryStreamName"
    rows={deliveryStreams}
    selectable={selectable}
    onSelect={onSelect}
    order={['DeliveryStreamName']}
    loading={loading}
    filterColumns={[
      'CreateTimestamp',
      'DeliveryStreamARN',
      'DeliveryStreamName',
      'DeliveryStreamStatus',
      'DeliveryStreamType',
      'Destinations',
      'LastUpdateTimestamp',
    ]}
    externalFields={{
      DeliveryStreamName: (row) => (
        <Link onClick={() => onViewStream?.(row)} underline="hover">
          {row.DeliveryStreamName}
        </Link>
      ),
    }}
  />
);
